import {
  AbstractControl, ValidatorFn, ValidationErrors, UntypedFormControl,
} from '@angular/forms';
import { CustomValidators } from 'shared/validation/custom-validators';
import * as moment from 'moment';
import * as _ from 'lodash';


export const expirationDateValidation = function (): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    const err = {'Expiration': 'Expiration date is required and must be XX/XX'};
    if (!control.value) { return err; }
    const value = control.value.slice(0, 2) + '/' + control.value.slice(2, 4);
    const match = value.match(/^[0-9][0-9]\/[0-9][0-9]$/);
    if (!value.length || !match) {
      return err;
    }

    // check if date is not expired
    const momentNow = moment();
    const enteredDate = value.split('/');
    try {
      const momentEntered = moment(`20${enteredDate[1]}-${enteredDate[0]}-01`);
      // check if expired
      if (
        !(momentEntered.diff(momentNow) > 0)
      ) {
        return {'Expiration': 'Card is expired'};
      }
    } catch (e) {
      // invalid date
      return {'Expiration': 'Expiration date is invalid'};
    }

    return null;
  };
};


export const cardNumberValidation = function (): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    const err = {'Card': 'Credit Card is invalid'};
    if (!control.value) { return err; }

    const testControl = new UntypedFormControl(control.value.replace(/-/g, ''));
    if (!_.isNil(CustomValidators.creditCard(testControl))) {
      return err;
    }

    return null;
  };
};
